import QuantitativeReport from '../components/QuantitativeReports/QuantitativeReport/quantitativeReport.vue'
import TimeReport from '../components/TimeReports/TimeReport/timeReport.vue'
import QualityControlReport from '../components/QualityControlReports/QualityControlReport/qualityControlReport.vue'
import MaintenaceCost from '../components/MaintenanceCosts/MaintenanceCost/maintenanceCost.vue'
import GenerateReport from '../components/GenerateReport/index.vue'

export default {
  components: {
    QuantitativeReport,
    TimeReport,
    QualityControlReport,
    MaintenaceCost,
    GenerateReport,
  },

  props: {
    scheduleTab: Boolean,
  },

  data: () => ({
    userType: null,
    visible: true,
    tab: null,
  }),

  methods: {},

  created() {
    this.userType = JSON.parse(localStorage.getItem('institution')).userType

    this.visible = this.userType < 5 || this.userType == 8

    if (this.scheduleTab) {
      this.tab = 'tabSchedule'
    }
  },
}
